import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function QuoteHeader() {
  return (
    <header className="w-full border-b border-[#1A1A1A] bg-[#0D0D0D]">
      <div className="max-w-lg mx-auto px-4 h-14 flex items-center gap-3">
        <AppLogo size={36} />
      </div>
    </header>
  );
}